const Merch = () => {
    return <h1>Merch Page</h1>;
};

export default Merch;
